import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";

import { updateFixture } from "../../redux/slices/tournamentSlice";
import ClubbieModal from "../Modal/ClubbieModal";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

const DeleteFixtureModal = ({ isOpen, onClose, fixture, onSuccess }) => {
  const dispatch = useDispatch();
  const { selectedTournament, selectedCategory } = useSelector(
    (state) => state.tournament
  );

  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    if (!fixture) return;

    setIsLoading(true);
    const loadingToast = toast.loading("Deleting fixture...");

    try {
      await dispatch(
        updateFixture({
          tournamentId: selectedTournament.id,
          categoryId: selectedCategory._id,
          phaseId: fixture.phaseId,
          blockId: fixture.blockId,
          fixtureId: fixture._id,
          fixtureData: { status: "CANCELLED" },
        })
      ).unwrap();

      toast.dismiss(loadingToast);
      toast.success("Fixture deleted successfully!");
      onSuccess?.();
      onClose();
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error(error.message || "Failed to delete fixture");
    } finally {
      setIsLoading(false);
    }
  };

  const footer = (
    <div className="flex justify-end gap-3 w-full">
      <button
        type="button"
        className="px-6 py-3 text-sm font-medium text-app-text bg-app-card rounded-full hover:text-[#FEFCEB] transition-colors cursor-pointer"
        onClick={onClose}
      >
        Cancel
      </button>
      <button
        type="button"
        className="px-6 py-3 rounded-full bg-app-error hover:bg-red-600 text-blue-shade-8 text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        onClick={handleDelete}
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <LoadingSpinner size="small" />
            <span>Deleting...</span>
          </>
        ) : (
          "Delete"
        )}
      </button>
    </div>
  );

  return (
    <ClubbieModal
      isOpen={isOpen}
      toggle={onClose}
      width="500px"
      title="Delete Fixture"
      footer={footer}
    >
      <p className="text-app-text-secondary text-[13px]">
        Are you sure you want to delete this fixture? This action cannot be undone.
      </p>
    </ClubbieModal>
  );
};

export default DeleteFixtureModal;
